import React from 'react';
import { View, Text, Image } from 'react-native';
import { Svg as Svgs } from 'assets/svg';
import VText from 'components/VText';
import { hp } from 'utils/normalise';
const PdpEmptyScreen = ({ title ,gender}) => {

    let icon ;
    switch (`${title} ${gender}`) {
        case 'Clothing male':
            icon = Svgs.clothingMan;
            break;
        case 'Clothing female':
            icon = Svgs.clothingWomen1;
            break;
        case 'Bags male':
            icon = Svgs.bagsMan;
            break;
        case 'Bags female':
            icon = Svgs.bagsWomen;
            break;
        case 'Shoes male':
            icon = Svgs.shoesMan;
            break;
        case 'Sport male':
            icon = Svgs.shoesMan;
            break;
        case 'Shoes female':
            icon = Svgs.shoes;
            break;
        case 'Accessories male':
            icon = Svgs.accessories;
            break;
        case 'Accessories female':
            icon = Svgs.accessories;
            break;
        case 'Jewelry and Watches male':
            icon = Svgs.watchMan;
            break;
        case 'Jewelry & Watches female':
            icon = Svgs.watchWomen;
            break;
        case 'Home male':
            icon = Svgs.home;
            break;
        case 'Home female':
            icon = Svgs.home;
        break;
        case 'Grooming male':
            icon = Svgs.beauty;
        break;

        case 'Beauty female':
            icon = Svgs.beauty;
            break;
        
        default:
            icon = Svgs.newArrivals;
        break;
            
    }


    return (
        <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center', marginTop: hp(40) }}>
            <Image accessibilityLabel={`${title} ${gender} Icon`} source={icon} />
            <VText style={{ fontSize: 16, fontWeight: 'bold', marginTop: hp(10) }}>No results found</VText>
        </View>
    );
};

export default PdpEmptyScreen;